import styled from 'styled-components';

export const CardContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(214px, 1fr));
  gap: 20px;
`;

export const PlansCardStyled = styled.div`
  border-radius: 10px;
  background-color: ${({ theme }) => theme.colors.disable};
  padding: 30px 20px;
  display: flex;
  flex-direction: column;
  gap: 30px;

  & p {
    color: ${({ theme }) => theme.colors.darkText};
  }

  .main-text {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    position: relative;
    gap: 16px;
  }

  .merits {
    display: flex;
    flex-direction: column;
    gap: 16px;
    & .merits-icon {
      display: flex;
      align-items: center;
      gap: 7px;

      & p {
        font-weight: 500;
        font-size: 14px;
        line-height: 25px;
      }
    }
  }
`;
